import type { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import "dayjs/locale/uz";
import { useMemo } from "react";
import { getDatesBetween } from "@/shared/utils/getDatesBetween";
import { PeriodSlotCell } from "../components/AttendanceTableCells";
import type { WorkerRow } from "../types";
import { getPeriodSlotDisplay } from "../utils/attendance.utils";

dayjs.locale("uz");

export function useAttendanceColumns(startDate: string, endDate: string): ColumnsType<WorkerRow> {
	const days = useMemo(
		() => getDatesBetween(new Date(startDate), new Date(endDate)),
		[startDate, endDate]
	);

	return useMemo(() => {
		const base: ColumnsType<WorkerRow> = [
			{
				title: "#",
				key: "index",
				width: 50,
				fixed: "left",
				render: (_: unknown, __: unknown, index: number) => index + 1,
			},
			{
				title: "F.I.O",
				dataIndex: "fullName",
				key: "fullName",
				fixed: "left",
				width: 180,
				className: "font-medium",
			},
			{
				title: "Tashkilot",
				dataIndex: "organizationName",
				key: "organization",
				width: 150,
			},
		];

		const dayCols = days.map((day) => {
			const dateLabel = dayjs(day).format("DD.MM.YYYY");
			return {
				key: `day-${day}`,
				title: <div className="text-center font-medium text-gray-700">{dateLabel}</div>,
				children: [
					{
						key: `morning-${day}`,
						title: (
							<div className="text-center bg-green-50 py-1">
								<span className="text-green-600 font-medium">Ertalab</span>
							</div>
						),
						width: 110,
						render: (_: unknown, record: WorkerRow) => (
							<PeriodSlotCell
								display={getPeriodSlotDisplay(record.attendanceByDate[day]?.morning ?? null)}
							/>
						),
					},
					{
						key: `noon-${day}`,
						title: (
							<div className="text-center bg-amber-50 py-1">
								<span className="text-amber-600 font-medium">Kunduz</span>
							</div>
						),
						width: 110,
						render: (_: unknown, record: WorkerRow) => (
							<PeriodSlotCell
								display={getPeriodSlotDisplay(record.attendanceByDate[day]?.noon ?? null)}
							/>
						),
					},
					{
						key: `evening-${day}`,
						title: (
							<div className="text-center bg-red-50 py-1">
								<span className="text-red-600 font-medium">Kechqurun</span>
							</div>
						),
						width: 110,
						render: (_: unknown, record: WorkerRow) => (
							<PeriodSlotCell
								display={getPeriodSlotDisplay(record.attendanceByDate[day]?.evening ?? null)}
							/>
						),
					},
				],
			};
		});

		return [...base, ...dayCols];
	}, [days]);
}
